<template>
  <section
    id="faqs"
    data-aos="fade"
    class="bg-[#f9f5f0] py-24 relative overflow-hidden sm:py-32"
  >
    <img
      :src="BeigeBorder"
      alt="Beige border squiggle"
      class="absolute h-8 -top-4 w-full"
      height="32"
      width="375"
    />
    <img
      :src="BeigeBorder"
      alt="Beige border squiggle"
      class="absolute h-8 -bottom-4 -scale-100 w-full"
      height="32"
      width="375"
    />
    <img
      :src="Squiggle"
      alt="Squiggle purple line"
      class="absolute -top-8 left-0 w-full opacity-5 h-[120%]"
      height="32"
      width="375"
    />
    <div class="mx-auto max-w-7xl px-6 relative lg:px-8">
      <div
        class="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-12 lg:mx-0 lg:max-w-none lg:grid-cols-5"
      >
        <div data-aos="fade-up" class="col-span-2 relative pb-4">
          <h2 class="text-base/7 font-semibold text-purple-600 relative">
            Questions & Answers
          </h2>
          <p
            class="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl"
          >
            Frequently asked questions
          </p>
        </div>
        <div class="col-span-full mb-4">
          <details
            v-for="item in faqs"
            :key="item.id"
            data-aos="fade-up"
            name="accordion"
            class="transition-all border-b last-of-type:border-b-0 border-gray-800/20"
          >
            <summary
              class="transition-all p-4 text-base/7 font-semibold flex justify-between items-center gap-2.5 cursor-pointer md:text-lg/7 lg:py-6"
            >
              <p>
                {{ item.title }}
              </p>
              <i class="fa-solid fa-chevron-down"></i>
            </summary>
            <div class="details-content-wrapper text-lg/7">
              <div class="pb-4">
                <p>{{ item.body }}</p>
              </div>
            </div>
          </details>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import BeigeBorder from "/graphics/expert-top.svg";
import Squiggle from "/graphics/purple/squiggle-5.svg";

const faqs = [
  {
    id: 1,
    title: "Who is the Juniper Education app for?",
    body: "The Juniper Education mobile app is designed for both teachers and parents. Based on your login credentials, the app shows you the most relevant information. Teachers can access features like comms, awards, observations and attendance, while parents can make bookings, view their children's achievements and stay up to date with school news.",
  },
  {
    id: 2,
    title: "How do I get started?",
    body: "You will receive an invite via email. Follow the link and download the app. You'll be up and running in minutes.",
  },
  {
    id: 3,
    title: "Can I message parents directly?",
    body: "Yes – the app includes secure messaging so you can contact individual parents or broadcast to the whole class. It’s fast, safe, and keeps all communication in one place.",
  },
  {
    id: 4,
    title: "How do rewards and points work?",
    body: "You can issue points and badges to celebrate student effort or achievement. Parents are notified instantly, helping to reinforce learning and behaviour at home.",
  },
  {
    id: 5,
    title: "Can I share photos or observations?",
    body: "Absolutely. Snap a photo or write a quick note – share class moments, learning highlights, or praise with just a few taps.",
  },
  {
    id: 6,
    title: "Does it integrate with my school MIS?",
    body: "Yes. The app integrates with most major MIS systems, pulling in class lists and more.",
  },
  {
    id: 7,
    title: "Is pupil data secure?",
    body: "Yes – everything is encrypted and compliant with your school’s data protection policy. Only verified users with appropriate permissions can view pupil information.",
  },
];
</script>

<style>
::details-content {
  transition: all 0.5s ease, content-visibility 0.5s allow-discrete;
  height: 0;
  overflow: clip;
}

@supports (interpolate-size: allow-keywords) {
  :root {
    interpolate-size: allow-keywords;
  }

  ::details-content {
    padding-inline: 1rem;
  }

  [open]::details-content {
    height: auto;
    padding: 0.5rem 1rem;
  }
}
@supports not (interpolate-size: allow-keywords) {
  [open]::details-content {
    height: 150px; /* In the future to be replaced by `height: auto` */
    overflow-y: scroll; /* In case the contents should be taller than 150px */
  }
}

details[open] {
  background-color: white;
}

details[open] > summary > i {
  transform: rotate(180deg);
}
</style>
